import { branchApi } from "../../api";

const BranchService = {
  fetchDropdown: async () => {
    const response = await branchApi.fetchCustom('/dropdown');
    return response.data;
  },

  fetchSalesDropdown: async () => {
    const response = await branchApi.fetchCustom('/sales-dropdown');
    return response.data;
  },

  /** Sucursal activa del usuario autenticado. */
  fetchMyBranch: async () => {
    const response = await branchApi.fetchCustom('/me');
    return response.data;
  },
};

export default BranchService;
